import { createFileRoute } from '@tanstack/react-router';
import { Support } from '@/components/legal';

// Public route - no auth required
export const Route = createFileRoute('/support')({
  component: Support,
});
